import React, { FC } from 'react';

import classNames from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';

import { IKnowledgeAreaLevelProps } from './knowledge-area-level.interface';
import styles from './knowledge-area-level.module.scss';

import { ActionMenu, Divider, Headline4, Util } from 'views/components';

const KnowledgeAreaLevel: FC<IKnowledgeAreaLevelProps> = props => {
  const {
    levelData,
    activeLevelId,
    handleActiveLevel,
    handleMenuOpen,
    handleEdit,
    handleRemove,
    indexLevel,
  } = props;
  const intl = useIntl();

  const indexLevelIncrement = indexLevel + 1;
  const isActive = levelData.id === activeLevelId;
  const levelColor = isActive ? 'var(--sk-text-default)' : 'var(--sk-text-subtle)';
  const levelClassNames = classNames(styles.level, {
    [styles.level__active]: isActive,
  });

  const onLevelKeyDown = (e: React.KeyboardEvent<HTMLDivElement>): void => {
    if (e.target === e.currentTarget && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      handleActiveLevel(levelData.id, e as unknown as React.MouseEvent<HTMLElement>);
    }
  };

  return (
    <div
      className={levelClassNames}
      onClick={e => handleActiveLevel(levelData.id, e)}
      onKeyDown={onLevelKeyDown}
      role="button"
      aria-pressed={isActive}
      tabIndex={0}
    >
      <div className={styles.level__inner}>
        <Headline4 color={levelColor}>
          <span className={styles.level__index}>{indexLevelIncrement}.</span>
          {levelData.name}
        </Headline4>
        <ActionMenu
          triggerAriaLabel={intl.formatMessage({
            id: 'action-menu.btn.more-options',
          })}
          onOpen={() => handleMenuOpen(levelData)}
          items={[
            {
              id: 'edit',
              label: <FormattedMessage id="action-menu.item.edit" />,
              onSelect: handleEdit,
            },
            {
              id: 'remove',
              label: <FormattedMessage id="action-menu.item.remove" />,
              onSelect: handleRemove,
              tone: 'danger',
            },
          ]}
          menuWidth="wide"
        />
        <div className={styles['active-border']} />
      </div>
      <Util paddingX="1.5rem">
        <Divider />
      </Util>
    </div>
  );
};

export { KnowledgeAreaLevel };
